import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../utils/apiAuth";

export const getUserById = createAsyncThunk(
  "user/getUsersById",
  async (requestedUserId, { rejectWithValue }) => {
    if (!requestedUserId) {
      return rejectWithValue("Geçersiz kullanıcı ID'si!");
    }
    try {
      const response = await api.get(`/users/${requestedUserId}`, {
        withCredentials: true,
      });
      if (!response.data || Object.keys(response.data).length === 0) {
        throw new Error("Kullanıcı verisi bulunamadı");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Kullanıcı bilgisi alınamadı."
      );
    }
  }
);
export const updateUserProfile = createAsyncThunk(
  "user/updateUserProfile",
  async ({ section, data }, { rejectWithValue }) => {
    try {
      let payload = {};
      if (section === "personalData") {
        payload = {
          name: data.name || "",
          gender: data.gender || "",
          birthDate: data.birthDate || "",
          address: data.address || "",
          position: data.position || "",
        };
      } else if (section === "contactData") {
        payload = {
          email: data.email || "",
          telephone: data.telephone || "",
          isEmailVerified: data.isEmailVerified,
        };
      } else if (section === "social_medias") {
        payload = {
          social_medias: Array.isArray(data.social_medias)
            ? data.social_medias
            : [],
        };
      } else if (section === "about") {
        payload = data;
      } else if (section === "skills") {
        payload = {
          skills: Array.isArray(data.skills)
            ? data.skills
            : Array.isArray(data)
            ? data
            : [],
        };
      } else if (section === "languages") {
        payload = {
          languages: Array.isArray(data.languages) ? data.languages : [],
        };
      } else if (section === "edu_cert") {
        payload = {
          edu_cert: Array.isArray(data.edu_cert) ? data.edu_cert : [],
        };
      } else {
        payload = { [section]: data || "" };
      }

      const response = await api.patch("/users", payload);

      return response.data;
    } catch (error) {
      console.error("Hata Oluştu - updateUserProfile:", error);
      if (error.response) {
        console.error("Backend Hatası - Status:", error.response.status);
        console.error("Backend Hatası - Data:", error.response.data);
      }

      // Check for duplicate email error
      if (
        error.response?.data?.message?.includes("dup key") &&
        error.response?.data?.message?.includes("email")
      ) {
        return rejectWithValue(
          "Bu e-posta adresi başka bir kullanıcı tarafından kullanılıyor."
        );
      }

      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Profil güncellenirken bir hata oluştu"
      );
    }
  }
);
// ... existing code ...

// ... existing code ...
